// ENTITY com.ic2.auth.refresh.ActiveSessionDTO generated by ic2 4.0.0-SNAPSHOT at Thu Oct 01 15:16:31 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';

export class ActiveSessionDTO {

  static readonly __ic2_fqn: string = 'com.ic2.auth.refresh.ActiveSessionDTO';

  idRefreshToken: number | null = 0;
  deviceInfo: string | null = '';
  lastActivityAt: Date | null = null;
  expiresAt: Date | null = null;
  idWebauthnCredential: number | null = null;
  kind: string | null = '';
  current: boolean | null = false;

  constructor(init?:Partial<ActiveSessionDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['com.ic2.auth.refresh.ActiveSessionDTO'] = ActiveSessionDTO;

fields['com.ic2.auth.refresh.ActiveSessionDTO']  = {
    idRefreshToken: 'java.lang.Integer',
    deviceInfo: 'java.lang.String',
    lastActivityAt: 'java.time.Instant',
    expiresAt: 'java.time.Instant',
    idWebauthnCredential: 'java.lang.Integer',
    kind: 'java.lang.String',
    current: 'java.lang.Boolean'
};
